import React from 'react';

import { subscriber_profile_path } from '../../../routes';
import { CommentUser } from '../../../utils/backend-api/comments';

export default function UserBylines({ user }: { user: CommentUser }) {
  return (
    <div className="inline-block" id="byline-author">
      <div className="author-meta inline-block">
        {user.profile_enabled ? (
          <a
            className="quiet-link author-link track-click"
            data-type="link"
            data-name="Contributor profile"
            data-location="byline"
            data-identifier={user.name}
            href={subscriber_profile_path(user.username)}
          >
            {user.name}
          </a>
        ) : (
          <strong className="bio-without-link">{user.name}</strong>
        )}
      </div>
    </div>
  );
}
